import s from "../clinic.module.css";
import { Button, Field, FormSection, Select } from "../../ui";
import TrainerAssignmentsFields, { toggleId } from "../AdminTeam/TrainerAssignmentsFields";

export default function AdminDoctorBranchesForm({
  branches,
  branchIds,
  onToggle,
  directions = [],
  groups = [],
  directionIds = [],
  groupIds = [],
  onChangeAssignments,
  onSave,
}) {
  const assigned = branches.filter((b) => branchIds.includes(b.id));
  const available = branches.filter((b) => !branchIds.includes(b.id));

  const addBranch = (e) => {
    const id = e.target.value;
    if (id) onToggle(id);
    e.target.value = "";
  };

  const setAssignments = (patch) => {
    onChangeAssignments?.(patch);
  };

  return (
    <>
      <FormSection
        title="Залы"
        description="Где тренер проводит занятия"
      >
        {branches.length === 0 ? (
          <p className={s.attachmentHint}>Сначала создайте зал в разделе «Залы»</p>
        ) : assigned.length === 0 ? (
          <p className={s.attachmentHint}>Тренер пока не привязан к залам</p>
        ) : (
          <div className={s.branchCheckGrid}>
            {assigned.map((b) => (
              <label key={b.id} className={s.branchCheckItem}>
                <input
                  type="checkbox"
                  checked
                  onChange={() => onToggle(b.id)}
                />
                <span>
                  <strong>{b.name}</strong>
                  {b.is_default ? (
                    <span className={s.branchCheckMeta}> · по умолчанию</span>
                  ) : null}
                </span>
              </label>
            ))}
          </div>
        )}

        {available.length > 0 ? (
          <Field label="Добавить зал" style={{ marginTop: 16 }}>
            <Select value="" onChange={addBranch}>
              <option value="">— выберите зал —</option>
              {available.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </Select>
          </Field>
        ) : null}
      </FormSection>

      {(directions.length > 0 || groups.length > 0) && onChangeAssignments ? (
        <FormSection
          title="Направления и группы"
          description="Тренер видит в расписании занятия своих групп и направлений"
        >
          <TrainerAssignmentsFields
            directions={directions}
            groups={groups}
            directionIds={directionIds}
            groupIds={groupIds}
            onToggleDirection={(id) =>
              setAssignments({ directionIds: toggleId(directionIds, id) })
            }
            onToggleGroup={(id) =>
              setAssignments({ groupIds: toggleId(groupIds, id) })
            }
          />
        </FormSection>
      ) : null}

      <Button type="button" style={{ marginTop: 16 }} onClick={onSave}>
        Сохранить
      </Button>
    </>
  );
}
